<template>
  <div>
    <img :src="logoProperfy" class="logo-properfy" width="200" />

    <h2 class="text-center title__principal mb-5">
      {{ $t('appointment.confirmAppointment.title') }}
    </h2>

    <!-- date info -->
     <div v-if="showDateInfo" class="d-flex flex-column align-center mb-5">
       <span class="body-2 mb-3 grey--text text--darken-2 font-weight-bold">
        <v-icon class="mr-1" color="grey darken-2" small>
          mdi-calendar-badge-outline
        </v-icon>
        {{ selectedDateLabel }}:
       </span>
      <v-card class="px-6 py-5" color="selected-date-container lighten-3 rounded-lg" elevation="0" outlined>
        <div class="d-flex flex-column align-center">
          <span v-if="newDateAndTime" class="text-h5 font-weight-bold	grey--text text--darken-3">
            <v-icon class="mr-2" color="success lighten-1" small>
              mdi-flag-outline
            </v-icon>
            {{ newDateAndTime }}
          </span>
          <span v-else class="d-flex align-center text-h5 font-weight-bold grey--text text--darken-3">
            {{ timeSlot(date, slotSize, appointmentData.timezone) }}
          </span>
        </div>
      </v-card>

       <v-btn
         v-if="isChangeDateAllowed"
         @click="checkUrlAndShowModal"
         elevation="0"
         color="primary"
         class="mt-1 mb-4"
         text
       >
         <span class="body-2">
           {{ selectNewDateLabel }}
         </span>
       </v-btn>
     </div>
    <!-- date info -->

    <p v-if="!emailNotSentOrInvalidStatus" class="mw-600 mb-10 ma-auto text-center">
      {{ $t('appointment.confirmAppointment.subtitle', { appointmentAddress: address, appointmentCode: code.toString() }) }}
    </p>
  </div>
</template>

<script>
import moment from 'moment-timezone'

import { mapActions } from 'vuex'

import { timeSlotAmPm } from '../../../util/catalog'

export default {
  name: 'ConfirmAppointmentHeader',

  props: {
    address: {
      type: String,
      required: true,
    },

    isLoading: {
      type: Boolean,
      required: false,
    },

    code: {
      type: String | Number,
      required: true,
    },

    status: {
      type: String,
      required: true,
    },

    appointmentData: {
      type: Object,
      required: true,
    },

    newAppointmentDateInfo: {
      type: Object,
      required: false,
    },
  },

  computed: {
    emailNotSentOrInvalidStatus() {
      return !this.isLoading && (this.status == 'CANCELED'
        || !this.confirmation
        || this.confirmation && !this.confirmation.sent_at && !this.confirmation.answered)
    },

    confirmation() {
      return this.appointmentData?.confirmation
    },

    logoProperfy() {
      const logo = this.appointmentData?.australian_customer ? 'logo-properfy.svg' : 'logo-hauseful.svg'
      return require(`@/assets/images/${logo}`)
    },

    date() {
      const confirmation = this.appointmentData?.confirmation
      let date = confirmation?.accepted_date ?? this.appointmentData?.date
      return moment(date)
    },

    slotSize() {
      return this.appointmentData?.slot_size
    },

    isChangeDateAllowed() {
      return this.$route?.query?.isChangeDateAllowed === 'true'
    },

    showDateInfo() {
      return !this.isLoading && !['CANCELED'].includes(this.status) && !this.emailNotSentOrInvalidStatus
    },
  },

  methods: {
    ...mapActions(['openModal']),

    checkUrlAndShowModal() {
      this.openModal('SelectAvailableDatesModal')
    },
  },

  data() {
    return {
      timeSlot: timeSlotAmPm,
      newDateAndTime: null,

      // labels
      selectedDateLabel: this.$t('appointment.confirmAppointment.availableDates.selectedDate'),
      selectNewDateLabel: this.$t('appointment.confirmAppointment.availableDates.selectAnotherDate'),
    }
  },

  watch: {
    newAppointmentDateInfo(newDateInfo) {
      if (newDateInfo) {
        this.newDateAndTime = this.timeSlot(newDateInfo.date, newDateInfo.slot_size, this.appointmentData?.timezone)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
$colorBaseLight: #e3f8ff;

.logo-properfy {
  display: block;
  margin: 40px auto 60px;
}

.selected-date-container {
  background-color: rgba($colorBaseLight, 1);
}
</style>
